import Component from '../core/component';
import Enhance from '../core/enhance';


/**
 * 父组件更新时Lock组件不会一起更新
 * 必须调用Lock组件对象的update来更新Lock组件的子节点
 */
class Lock extends Component {
    state = {};

    /**
     *
     * @param props
     * @param context
     */
    constructor(props, context) {
        super(props, context);

    }

    /**
     * shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    /**
     *
     * @returns {null}
     */
    render() {
        return <div className="c-lock">{this.props.children}</div>;
    }

    /**
     * 旧方法
     * @param callback
     */
    update = (callback) => {
        this.forceUpdate(callback);
    }
}

Enhance(Lock, {}, 'Lock');
export default Lock;